if (!customElements.get('ingredients-slider')) {
  class IngredientsSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.mainSwiper = new Swiper(this.querySelector('[js-main-slider]'), {
        slidesPerView: 'auto',
        allowTouchMove: true,
        centeredSlides: true,
        spaceBetween: 10,
        autoHeight: true,
        loop: true,
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
        breakpoints: {
          750: {
            spaceBetween: 12,
          },
        },
      });
    }
  }

  customElements.define('ingredients-slider', IngredientsSlider);
}
